var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.278,
    height: 21,
    viewBox: "0 0 19.278 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9919",
    "data-name": "Group 9919",
    transform: "translate(174.515 2967.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1824",
    "data-name": "Ellipse 1824",
    cx: 1.878,
    cy: 1.854,
    rx: 1.878,
    ry: 1.854,
    transform: "translate(-166.865 -2958.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7139",
    "data-name": "Path 7139",
    className: "cls-1",
    d: "M13.751,16.2a9.126,9.126,0,1,1-7.654,0",
    transform: "translate(-174.8 -2980.612)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1108",
    "data-name": "Line 1108",
    className: "cls-1",
    y2: 5.204,
    transform: "translate(-164.987 -2967)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2c9ef6475f196e63a4b8ed5f7986ce1c.svg";
export { ForwardRef as ReactComponent };